export default __webpack_public_path__ + "f324fc6598826ed57d62a00baf7f4b4c.svg";